<form class="w-100 h-100 form" [formGroup]="Form">
  <h4 class="text-center">Detalle de Solicitud</h4>
  <div class="row mx-0 mt-3 pt-0 pb-0 w-100">
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Primer Nombre</mat-label>
        <input matInput formControlName="name" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Name != undefined">Antes: {{previousValues.Name}}
        </mat-hint>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Segundo Nombre</mat-label>
        <input matInput formControlName="secondName" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.SecondName != undefined">Antes:
          {{previousValues.SecondName}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Apellido Parterno</mat-label>
        <input matInput formControlName="lastName" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.LastName != undefined">Antes:
          {{previousValues.LastName}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Apellido Materno</mat-label>
        <input matInput formControlName="secondLastName" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.SecondLastName != undefined">Antes:
          {{previousValues.SecondLastName}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Género</mat-label>
        <input matInput formControlName="gender" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Gender != undefined">Antes:
          {{previousValues.Gender}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Estado civil</mat-label>
        <input matInput formControlName="civilStatus" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.CivilStatus != undefined">Antes:
          {{previousValues.CivilStatus}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Documento</mat-label>
        <input matInput formControlName="document" readonly>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Fecha de nacimiento</mat-label>
        <input matInput readonly formControlName="dateNac">
        <mat-hint align="end" *ngIf="previousValues && previousValues.DateNac != undefined">Antes:
          {{previousValues.DateNac}}</mat-hint>
      </mat-form-field>
    </div>


    <!-- Phone2.... -->
    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Télefono</mat-label>
        <input matInput formControlName="phone" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Phone != undefined">Antes:
          {{previousValues.Phone}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Télefono 2</mat-label>
        <input matInput formControlName="phone2" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Phone2 != undefined">Antes:
          {{previousValues.Phone2}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Télefono 3</mat-label>
        <input matInput formControlName="phone3" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Phone3 != undefined">Antes:
          {{previousValues.Phone3}}</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Correo</mat-label>
        <input matInput formControlName="email" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Email != undefined">Antes:
          {{previousValues.Email}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Correo 2</mat-label>
        <input matInput formControlName="email2" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Email2 != undefined">Antes:
          {{previousValues.Email2}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Correo 3</mat-label>
        <input matInput formControlName="email3" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Email3 != undefined">Antes:
          {{previousValues.Email3}}</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>País</mat-label>
        <input matInput formControlName="country" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Country != undefined">Antes:
          {{previousValues.Country == 0? '' : previousValues.Country | uppercase}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Departamento</mat-label>
        <input matInput formControlName="department" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Department != undefined">Antes:
          {{previousValues.Department}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Provincia</mat-label>
        <input matInput formControlName="province" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Province != undefined">Antes:
          {{previousValues.Province}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Distrito</mat-label>
        <input matInput formControlName="district" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.District != undefined">Antes:
          {{previousValues.District}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Dirección</mat-label>
        <input matInput formControlName="address" readonly>
        <mat-hint align="end" *ngIf="previousValues && previousValues.Address != undefined">Antes:
          {{previousValues.Address}}</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <div class="bottom-button">
    <button class="vs-btn-blue" (click)="close()">
      Cerrar
    </button>
  </div>
</form>